<template>
    <div class="page">
      <!-- Upload / signature in progress: ask operator not to close -->
      <div v-if="uploadingImage || uploadingSignature" class="upload-overlay">
        <div class="upload-overlay-box">
          <div class="upload-spinner" aria-hidden="true"></div>
          <p class="upload-message">
            {{ uploadingImage ? 'Subiendo imagen, no cierres esta pantalla.' : 'Subiendo firma, no cierres esta pantalla.' }}
          </p>
          <p class="upload-hint">El sistema está guardando. Espera a que termine.</p>
          <div v-if="uploadingImage" class="upload-progress-wrap">
            <div class="upload-progress-bar">
              <div class="upload-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
            </div>
            <span class="upload-progress-pct">{{ uploadProgress }}%</span>
          </div>
        </div>
      </div>

      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="top-spacer" />
  
      <!-- Header -->
      <header class="page-head">
        <div class="title">
          <h2>Detalle de Orden</h2>
          <span class="chip chip-id" v-if="assignation?.id">ID #{{ assignation.id }}</span>
        </div>
        <div class="head-actions">
          <button class="btn btn-primary" @click="getUserLocationAndOpenGoogleMaps">
            Abrir en Google Maps
          </button>
        </div>
      </header>
  
      <!-- Content grid -->
      <section class="grid">
        <!-- Resumen -->
        <article class="card span-2">
          <div class="card-head">
            <h3>Resumen</h3>
            <span class="chip">{{ assignation?.assistance_note_type || '—' }}</span>
          </div>
          <div class="card-body">
            <div class="info-grid">
              <div class="info-block">
                <h4>Cliente</h4>
                <p class="mono" v-if="assignation?.assistance_note?.vehicle_owner_name">
                  <b>Nombre:</b> {{ assignation.assistance_note.vehicle_owner_name }}<br>
                </p>
                <p v-else>—</p>
              </div>
              <div class="info-block">
                <h4>Origen</h4>
                <p class="mono" v-if="assignation?.assistance_note?.source">
                  <b>Calle:</b> {{ assignation.assistance_note.source.street_name }}<br>
                  <b>Número:</b> {{ assignation.assistance_note.source.number }}<br>
                  <b>Entre calles:</b> {{ assignation.assistance_note.source.between_streets }}<br>
                  <b>Colonia:</b> {{ assignation.assistance_note.source.neighborhood }}<br>
                  <b>Ciudad:</b> {{ assignation.assistance_note.source.city }}<br>
                  <b>Estado:</b> {{ assignation.assistance_note.source.state }}
                </p>
                <p v-else>—</p>
              </div>
              <div class="info-block">
                <h4>Destino</h4>
                <p class="mono" v-if="assignation?.assistance_note?.destination">
                  <b>Calle:</b> {{ assignation.assistance_note.destination.street_name }}<br>
                  <b>Número:</b> {{ assignation.assistance_note.destination.number }}<br>
                  <b>Entre calles:</b> {{ assignation.assistance_note.destination.between_streets }}<br>
                  <b>Colonia:</b> {{ assignation.assistance_note.destination.neighborhood }}<br>
                  <b>Ciudad:</b> {{ assignation.assistance_note.destination.city }}<br>
                  <b>Estado:</b> {{ assignation.assistance_note.destination.state }}
                </p>
                <p v-else>—</p>
              </div>
              <div class="info-block">
                <h4>Vehículo</h4>
                <p class="mono">
                  <b>Marca:</b> {{ assignation?.assistance_note_brand || '—' }}<br>
                  <b>Submarca:</b> {{ assignation?.assistance_note_subbrand || '—' }}<br>
                  <b>Color:</b> {{ assignation?.assistance_note?.vehicle_color || '—' }}<br>
                  <b>Placas:</b> {{ assignation?.assistance_note?.vehicle_plates || '—' }}
                </p>
              </div>
              <div class="info-block">
                <h4>Referencias</h4>
                <p class="mono">
                  <b>Origen:</b> {{ assignation?.assistance_note?.source_notes || '—' }}<br>
                  <b>Destino:</b> {{ assignation?.assistance_note?.destination_notes || '—' }}
                </p>
              </div>
            </div>
          </div>
        </article>
  
        <!-- Mapa -->
        <article class="card">
          <div class="card-head">
            <h3>Ruta</h3>
          </div>
          <div class="card-body">
            <div id="map" class="map"></div>
          </div>
        </article>
  
        <!-- Registro de tiempos -->
        <article class="card">
          <div class="card-head">
            <h3>Registro de tiempos</h3>
          </div>
          <div class="card-body">
            <div v-if="!assignation.start_time && OkButton" class="accept-wrap desktop-only">
              <button class="btn btn-primary btn-lg" @click="showButtons">Aceptar orden</button>
            </div>
  
            <!-- Swipeable stepper on mobile -->
            <div v-if="assignation.start_time || showButtonsforOperator" class="time-grid">
  <button
    class="time-btn"
    :class="{ done: !!assignation.start_time }"
    @click="!assignation.start_time && confirmAndSendDateTime('inicio', 'start_time')"
  >
    <span class="time-title">Inicio</span>
    <span class="time-sub" v-if="assignation.start_time">{{ new Date(assignation.start_time).toLocaleString() }}</span>
  </button>

  <button
    class="time-btn"
    :class="{ done: !!assignation.arrival_time, disabled: !assignation.start_time }"
    @click="assignation.start_time && !assignation.arrival_time && confirmAndSendDateTime('arribo', 'arrival_time')"
  >
    <span class="time-title">Arribo</span>
    <span class="time-sub" v-if="assignation.arrival_time">{{ new Date(assignation.arrival_time).toLocaleString() }}</span>
  </button>

  <button
    class="time-btn"
    :class="{ done: !!assignation.contact_time, disabled: !assignation.arrival_time }"
    @click="assignation.arrival_time && !assignation.contact_time && confirmAndSendDateTime('contacto', 'contact_time')"
  >
    <span class="time-title">Contacto</span>
    <span class="time-sub" v-if="assignation.contact_time">{{ new Date(assignation.contact_time).toLocaleString() }}</span>
  </button>

  <button
    class="time-btn"
    :class="{ done: !!assignation.end_time, disabled: !assignation.contact_time }"
    @click="assignation.contact_time && !assignation.end_time && confirmAndSendDateTime('termino', 'end_time')"
  >
    <span class="time-title">Término</span>
    <span class="time-sub" v-if="assignation.end_time">{{ new Date(assignation.end_time).toLocaleString() }}</span>
  </button>
</div>

          </div>
        </article>
  
        <!-- Tacómetro -->
        <article class="card">
          <div class="card-head">
            <h3>Kilometraje</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="field">
                <label for="start_km">KM inicio</label>
                <input
                  type="text"
                  id="start_km"
                  v-model="assignation.start_km"
                  inputmode="decimal"
                  pattern="[0-9]*"
                  placeholder="Ingrese el km de inicio"
                />
              </div>
              <div class="field">
                <label for="end_km">KM fin</label>
                <input
                  type="text"
                  id="end_km"
                  v-model="assignation.end_km"
                  inputmode="decimal"
                  pattern="[0-9]*"
                  placeholder="Ingrese el km de fin"
                />
              </div>
              <div class="actions-end">
                <button class="btn btn-success" id="updateAssignationButton" @click="updateUnitTachometer">Actualizar</button>
              </div>
            </div>
          </div>
        </article>
  
        <!-- Inventario -->
        <article class="card span-2">
          <div class="card-head">
            <h3>Inventario del vehículo</h3>
          </div>
          <div class="card-body">
            <details open class="accordion">
              <summary>Elementos</summary>
              <div class="check-grid">
                <label class="check" v-for="item in checkItems" :key="item.key">
                  <input type="checkbox" v-model="assignation.assistance_note.vehicle_inventory[item.key]" />
                  <span>{{ item.label }}</span>
                </label>
              </div>
            </details>
  
            <details open class="accordion">
              <summary>Detalles</summary>
              <div class="form-grid">
                <div class="field">
                  <label>Marca batería</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.marcaBateria" type="text" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Marca radio estéreo</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.marcaRadio" type="text" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Número de bocinas</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.numeroBocinas" type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Número de herramientas</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.numeroHerramientas" type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Tipo de gato</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.tipoGato" type="text" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Marca llanta de refacción</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.marcaLlantaRefaccion" type="text" placeholder="Comentarios" />
                </div>
                <div class="field">
                  <label>Rines</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.rines" type="text" placeholder="Originales u otra marca" />
                </div>
                <div class="field">
                  <label>Marca llantas del vehículo</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.marcaLlantasVehiculo" type="text" placeholder="Comentarios" />
                </div>
              </div>
  
              <div class="tire-grid">
                <div class="field">
                  <label>Delantera Izq</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.vidaLlantasdelanteraIzq" type="text" inputmode="numeric" placeholder="%" />
                </div>
                <div class="field">
                  <label>Delantera Der</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.vidaLlantasdelanteraDer" type="text" inputmode="numeric" placeholder="%" />
                </div>
                <div class="field">
                  <label>Trasera Izq</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.vidaLlantastraseraIzq" type="text" inputmode="numeric" placeholder="%" />
                </div>
                <div class="field">
                  <label>Trasera Der</label>
                  <input v-model="assignation.assistance_note.vehicle_inventory.vidaLlantastraseraDer" type="text" inputmode="numeric" placeholder="%" />
                </div>
              </div>
  
              <div class="actions-end">
                <button class="btn btn-success" @click="saveInventory">Actualizar inventario</button>
              </div>
            </details>
          </div>
        </article>
  
        <!-- Evidencia -->
        <article class="card span-2">
          <div class="card-head">
            <h3>Evidencia fotográfica</h3>
          </div>
          <div class="card-body">
            <div class="gallery">
              <div class="gallery-section" v-for="section in imageSections" :key="section.loc">
                <div class="gallery-head">
                  <h4>{{ section.label }}</h4>
                  <button class="btn btn-light" @click="uploadFile(section)">Subir imagen</button>
                </div>
  
                <div class="thumbs">
                  <div class="thumb" v-if="section.images.default">
                    <img :src="section.images.default" alt="default">
                  </div>
                  <div class="thumb" v-for="(image, index) in section.images.uploaded" :key="index">
                    <img :src="image" alt="evidencia" />
                    <button class="thumb-delete" @click="deleteImage(section, index)">×</button>
                  </div>
                  <p v-if="!section.images.default && !section.images.uploaded.length" class="empty">
                    No hay imágenes aún.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
  
        <!-- Firma -->
        <article class="card">
          <div class="card-head">
            <h3>Firma del cliente</h3>
          </div>
          <div class="card-body">
            <div class="signature">
              <canvas ref="signatureCanvas" class="signature-canvas"></canvas>
            </div>
            <div class="sig-actions">
              <button class="btn btn-light" @click="clearSignature">Limpiar</button>
              <button class="btn btn-primary" @click="saveSignature">Guardar firma</button>
            </div>
          </div>
        </article>
      </section>
  
      <!-- Sticky mobile action bar -->
      <div class="mobile-cta">
        <button class="btn btn-primary cta" @click="getUserLocationAndOpenGoogleMaps">Google Maps</button>
        <button
          v-if="!assignation.start_time && OkButton"
          class="btn btn-success cta"
          @click="showButtons"
        >
          Aceptar orden
        </button>
      </div>
    </div>
  </template>
  
  <style scoped>
  /* Mobile-first */
  :root {
    --bg: #f6f7fb;
    --card-bg: #ffffff;
    --text: #1e1e1e;
    --muted: #6b7280;
    --border: #e5e7eb;
    --brand: #ffc434;
    --brand-600: #e6b12e;
    --ok: #16a34a;
    --chip: #111827;
    --radius: 14px;
    --container: 1200px;
  }
  
  .page { background: var(--bg); min-height: 100vh; padding-bottom: calc(64px + env(safe-area-inset-bottom)); }
  .top-spacer { height: 10vh; }
  
  /* App bar */
  .nav-bar-operations { position: fixed; inset: 0 0 auto 0; height: 10vh; background: var(--brand); z-index: 1000; }
  .logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; }
  
  /* Header */
  .page-head { max-width: var(--container); margin: 12px auto 8px; padding: 0 12px; display: flex; align-items: center; justify-content: space-between; }
  .page-head h2 { margin: 0; font-size: 1.15rem; color: var(--text); }
  .head-actions { display: none; } /* Hidden on mobile; shown on desktop below */
  
  /* Grid */
  .grid { max-width: var(--container); margin: 0 auto 40px; padding: 0 12px; display: grid; grid-template-columns: 1fr; gap: 12px; }
  .span-2 { grid-column: span 1; }
  
  .card { background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: 0 6px 24px rgba(0,0,0,.06); overflow: hidden; }
  .card-head { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-bottom: 1px solid var(--border); }
  .card-head h3 { margin: 0; font-size: 1rem; }
  .card-body { padding: 12px 14px; }
  
  /* Info blocks */
  .info-grid { display: grid; grid-template-columns: 1fr; gap: 12px; }
  .info-block h4 { margin: 0 0 6px; font-size: .95rem; color: var(--muted); }
  .mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
  
  /* Map */
  .map { width: 100%; height: 32vh; border-radius: 10px; overflow: hidden; background: #e9eef5; }
  
  /* Stepper – swipeable on mobile */
  .stepper {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 78%;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 6px;
    scroll-snap-type: x mandatory;
  }
  .stepper::-webkit-scrollbar { height: 6px; }
  .stepper::-webkit-scrollbar-thumb { background: #d4d4d4; border-radius: 999px; }
  
  .step {
    scroll-snap-align: start;
    background: #fafafa; border: 1px solid var(--border); border-radius: 12px; padding: 10px;
    display: grid; gap: 4px; text-align: center;
  }
  .step.disabled { opacity: .6; pointer-events: none; }
  .step.done { border-color: var(--ok); background: #f0fff4; }
  .step-index { width: 30px; height: 30px; border-radius: 999px; display: inline-flex; align-items: center; justify-content: center; background: #f3f4f6; margin: 0 auto; font-weight: 700; }
  .step.done .step-index { background: var(--ok); color: #fff; }
  .step-title { font-weight: 600; font-size: .95rem; }
  .step-time { font-size: .8rem; color: var(--muted); }
  
  /* Forms */
  .form-row { display: grid; grid-template-columns: 1fr; gap: 10px; align-items: end; }
  .field { display: grid; gap: 6px; }
  label { font-size: .95rem; color: var(--muted); }
  input[type="text"] {
    height: 44px; padding: 0 12px; border-radius: 10px; border:1px solid var(--border); outline: none; font-size: 16px; /* 16px to prevent iOS zoom */
  }
  input[type="text"]:focus { border-color:#cbd5e1; box-shadow: 0 0 0 3px rgba(255,196,52,.22); }
  
  /* Inventory */
  .accordion summary { cursor: pointer; font-weight: 700; margin-bottom: 8px; }
  .check-grid { display: grid; grid-template-columns: 1fr; gap: 10px; }
  .check { display:flex; align-items: center; gap:10px; background: #fafafa; padding: 10px 12px; border-radius: 10px; border:1px solid var(--border); }
  .check input { width: 20px; height: 20px; }
  
  /* Extra fields */
  .form-grid { display:grid; grid-template-columns: 1fr; gap: 10px; margin-top: 8px; }
  .tire-grid { display:grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 6px; }
  
  /* Gallery – horizontal scroller on mobile */
  .gallery { display: grid; gap: 14px; }
  .gallery-section { border: 1px dashed var(--border); border-radius: 12px; padding: 12px; }
  .gallery-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
  .thumbs { display: flex; gap: 10px; overflow-x: auto; }
  .thumb { position: relative; min-width: 48%; border: 1px solid var(--border); border-radius: 10px; overflow: hidden; background:#f9fafb; }
  .thumb img { width: 100%; height: 140px; object-fit: cover; display:block; }
  .thumb-delete { position: absolute; top: 6px; right: 6px; border: none; background: rgba(0,0,0,.6); color:#fff; width:28px; height:28px; border-radius: 999px; }
  
  /* Signature */
  .signature { width: 100%; height: 180px; border: 1px solid var(--border); border-radius: 10px; overflow: hidden; background: #fff; }
  .signature-canvas { width: 100%; height: 100%; display: block; }
  .sig-actions { display:flex; gap: 8px; justify-content: flex-end; margin-top: 10px; }
  
  /* Chips & buttons */
  .chip { display: inline-flex; align-items: center; height: 28px; padding: 0 10px; border-radius: 999px; font-weight: 600; background: #f3f4f6; color: var(--chip); border: 1px solid var(--border); }
  .chip-id { background: #fff7ed; border-color: #fed7aa; color: #9a3412; }
  
  .btn { min-height: 44px; padding: 0 14px; border-radius: 12px; border: 1px solid var(--border); cursor: pointer; font-weight: 700; background:#fff; touch-action: manipulation; }
  .btn:hover { background:#f9fafb; }
  .btn-lg { min-height: 48px; padding: 0 18px; font-size: 1rem; }
  .btn-primary { background: var(--brand); border-color: #f4c23a; }
  .btn-primary:hover { background: var(--brand-600); }
  .btn-success { background: var(--ok); color: #fff; border-color: #16a34a; }
  .btn-light { background: #f3f4f6; }

  /* Upload / signature in progress overlay */
  .upload-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
  .upload-overlay-box {
    background: #fff;
    border-radius: 16px;
    padding: 28px 32px;
    max-width: 360px;
    width: 100%;
    text-align: center;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }
  .upload-spinner {
    width: 48px;
    height: 48px;
    margin: 0 auto 16px;
    border: 4px solid #e5e7eb;
    border-top-color: var(--brand, #f4c23a);
    border-radius: 50%;
    animation: upload-spin 0.9s linear infinite;
  }
  @keyframes upload-spin {
    to { transform: rotate(360deg); }
  }
  .upload-message {
    font-size: 1.1rem;
    font-weight: 700;
    color: #111;
    margin: 0 0 8px;
  }
  .upload-hint {
    font-size: 0.9rem;
    color: #6b7280;
    margin: 0 0 16px;
  }
  .upload-progress-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
  }
  .upload-progress-bar {
    flex: 1;
    height: 10px;
    background: #e5e7eb;
    border-radius: 999px;
    overflow: hidden;
  }
  .upload-progress-fill {
    height: 100%;
    background: var(--brand, #f4c23a);
    border-radius: 999px;
    transition: width 0.2s ease;
  }
  .upload-progress-pct {
    font-size: 0.9rem;
    font-weight: 700;
    min-width: 2.5em;
    color: #374151;
  }
  
  /* Sticky mobile CTA */
  .mobile-cta {
    position: fixed; left: 0; right: 0; bottom: 0;
    padding: 10px calc(12px + env(safe-area-inset-right)) calc(10px + env(safe-area-inset-bottom)) calc(12px + env(safe-area-inset-left));
    background: rgba(255,255,255,.92); backdrop-filter: blur(6px);
    border-top: 1px solid var(--border);
    display: flex; gap: 10px; justify-content: space-between; z-index: 1001;
  }
  .mobile-cta .cta { flex: 1; }
  
  /* Show desktop enhancements */
  @media (min-width: 720px) {
    .page { padding-bottom: 0; }
    .grid { grid-template-columns: 1fr 1fr; gap: 14px; }
    .span-2 { grid-column: 1 / -1; }
    .map { height: 280px; }
    .head-actions { display: block; }
    .desktop-only { display: flex; }
    .mobile-cta { display: none; }
    .check-grid { grid-template-columns: repeat(2, 1fr); }
    .form-grid { grid-template-columns: repeat(2, 1fr); }
    .tire-grid { grid-template-columns: repeat(4, 1fr); }
    .thumb { min-width: 180px; }
  }
  @media (min-width: 1100px) {
    .grid { grid-template-columns: repeat(3, 1fr); }
  }

  /* --- Time registry: 4 fixed buttons, no scrolling --- */
.time-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;   /* 2x2 on mobile */
  gap: 10px;
}
.time-btn {
  min-height: 56px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--border, #e5e7eb);
  background: #fff;
  font-weight: 700;
  text-align: center;
}
.time-btn .time-title { display:block; font-size: 0.95rem; }
.time-btn .time-sub   { display:block; font-size: 0.8rem; color: var(--muted, #6b7280); margin-top: 2px; }
.time-btn.done { background: #f0fff4; border-color: #16a34a; }
.time-btn.disabled { opacity: .6; pointer-events: none; }

/* On tablet/desktop show 4 in a row */
@media (min-width: 720px) {
  .time-grid { grid-template-columns: repeat(4, 1fr); }
}

/* --- Fix tiny inputs on mobile (full width, proper height) --- */
.field input,
.field select,
.field textarea {
  width: 100%;
  min-height: 48px;          /* larger touch target */
  font-size: 16px;           /* prevents iOS zoom */
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--border, #e5e7eb);
  box-sizing: border-box;
  display: block;
  -webkit-appearance: none;  /* iOS quirks */
  appearance: none;
}

/* Make sure form grids give inputs room */
.form-grid,
.form-row { grid-template-columns: 1fr; }

.tire-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
@media (min-width: 720px) {
  .form-grid  { grid-template-columns: repeat(2, 1fr); }
  .tire-grid  { grid-template-columns: repeat(4, 1fr); }
}

  </style>
  
  <script>
  /* global google */
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import Compressor from 'compressorjs';
  import SignaturePad from 'signature_pad';
  
  export default {
    props: ['assignations'],
    data() {
      return {
        assignation: {
          assistance_note: {
            vehicle_inventory: {
              extinguidor: null, cablesPasaCorriente: null, llaveBirloSeguridad: null, llaveRuedas: null,
              senalesCarretera: null, tarjetaCirculacion: null, permisoImportacion: null, llaves: null,
              llavero: null, control: null, antena: null, canastilla: null, emblemas: null,
              espoilersDelantero: null, espoilersTrasero: null, taponesRuedas: null, taponGasolina: null,
              tapaArmellaEnganche: null, portaPlacas: null, placasDelanteras: null, placasTrasera: null,
              toldo: null, quemacocos: null, marcaBateria: '', marcaRadio: '', numeroBocinas: '',
              numeroHerramientas: '', tipoGato: '', marcaLlantaRefaccion: '', rines: '',
              marcaLlantasVehiculo: '', vidaLlantasdelanteraIzq: '', vidaLlantasdelanteraDer: '',
              vidaLlantastraseraIzq: '', vidaLlantastraseraDer: '',
            },
            source: { lat: null, lon: null },
            destination: { lat: null, lon: null },
          },
          client_signature: null,
        },
  
        OkButton: true,
        showButtonsforOperator: false,
  
        mapCenter: { lat: 25.6866, lng: -100.3161 },
        origin: { lat: 25.6866, lng: -100.3161 },
        destination: { lat: 25.7, lng: -100.3 },
  
        imageSections: [
          { loc: 'front', label: 'Frente del vehículo', images: { default: '', uploaded: [], blob_ids: [] } },
          { loc: 'engine', label: 'Motor', images: { default: '', uploaded: [], blob_ids: [] } },
          { loc: 'left', label: 'Lado izquierdo', images: { default: '', uploaded: [], blob_ids: [] } },
          { loc: 'right', label: 'Lado derecho', images: { default: '', uploaded: [], blob_ids: [] } },
          { loc: 'back', label: 'Parte trasera', images: { default: '', uploaded: [], blob_ids: [] } },
          { loc: 'complementary', label: 'Complementarias (llantas, cajuela, interior...)', images: { default: '', uploaded: [], blob_ids: [] } },
        ],

        signaturePad: null,

        uploadingImage: false,
        uploadingSignature: false,
        uploadProgress: 0,
      };
    },
  
    computed: {
      checkItems() {
        return [
          { key: 'extinguidor', label: 'Extinguidor' },
          { key: 'cablesPasaCorriente', label: 'Cables pasa corriente' },
          { key: 'llaveBirloSeguridad', label: 'Llave de birlo de seguridad' },
          { key: 'llaveRuedas', label: 'Llave de ruedas' },
          { key: 'senalesCarretera', label: 'Señales de carretera' },
          { key: 'tarjetaCirculacion', label: 'Tarjeta de circulación' },
          { key: 'permisoImportacion', label: 'Permiso de importación' },
          { key: 'llaves', label: 'Llaves' },
          { key: 'llavero', label: 'Llavero' },
          { key: 'control', label: 'Control' },
          { key: 'antena', label: 'Antena' },
          { key: 'canastilla', label: 'Canastilla' },
          { key: 'emblemas', label: 'Emblemas' },
          { key: 'espoilersDelantero', label: 'Espoilers delantero' },
          { key: 'espoilersTrasero', label: 'Espoilers trasero' },
          { key: 'taponesRuedas', label: 'Tapones ruedas' },
          { key: 'taponGasolina', label: 'Tapón gasolina' },
          { key: 'tapaArmellaEnganche', label: 'Tapa armella enganche' },
          { key: 'portaPlacas', label: 'Porta placas' },
          { key: 'placasDelanteras', label: 'Placas delanteras' },
          { key: 'placasTrasera', label: 'Placas trasera' },
          { key: 'toldo', label: 'Toldo' },
          { key: 'quemacocos', label: 'Quemacocos' },
        ];
      },
    },
  
    mounted() {
      // Signature init
      const canvas = this.$refs.signatureCanvas;
      this.signaturePad = new SignaturePad(canvas, { throttle: 16, penColor: 'black', backgroundColor: 'rgba(255,255,255,1)' });
      window.addEventListener('resize', this.resizeCanvas);
      this.resizeCanvas();
    },
  
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeCanvas);
    },
  
    methods: {
      backMainPanel() {
        window.location.href = '/operator-interface';
      },
  
      // Signature
      resizeCanvas() {
        const canvas = this.$refs.signatureCanvas;
        if (!canvas) return;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const rect = canvas.getBoundingClientRect();
        const cssWidth = Math.floor(rect.width);
        const cssHeight = Math.floor(rect.height);
        if (!cssWidth || !cssHeight) return;

        const nextWidth = Math.floor(cssWidth * ratio);
        const nextHeight = Math.floor(cssHeight * ratio);

        // Mobile browsers can fire resize while scrolling; skip if canvas size did not really change.
        if (canvas.width === nextWidth && canvas.height === nextHeight) return;

        const signatureImage = canvas.toDataURL('image/png');
        const ctx = canvas.getContext('2d');
        canvas.width = nextWidth;
        canvas.height = nextHeight;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(ratio, ratio);

        if (signatureImage && signatureImage !== 'data:,') {
          this.signaturePad.fromDataURL(signatureImage, { width: cssWidth, height: cssHeight });
        } else {
          this.signaturePad.clear();
        }
      },
      clearSignature() { this.signaturePad.clear(); },
      loadSignature(signatureDataUrl) {
        const img = new Image();
        img.onload = () => {
          const canvas = this.$refs.signatureCanvas;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.clientWidth, canvas.clientHeight);
        };
        img.src = signatureDataUrl;
      },
      async saveSignature() {
        if (this.signaturePad.isEmpty()) {
          Swal.fire('¡Error!', 'La firma está vacía. Por favor, firme antes de guardar.', 'error');
          return;
        }
        const signatureDataUrl = this.signaturePad.toDataURL('image/png');
        const payload = { client_signature: signatureDataUrl, assignation_id: this.assignation.id };
        const apiDirectory = process.env.API_DIRECTORY;

        this.uploadingSignature = true;
        try {
          await axios.post(`${apiDirectory}/save-signature/`, payload);
          // Keep local state in sync so later updates never carry a stale null signature.
          this.assignation.client_signature = signatureDataUrl;
          Swal.fire('¡Completado!', 'La firma se guardó correctamente.', 'success');
        } catch (e) {
          Swal.fire('¡Error!', 'Ocurrió un error al guardar la firma. Intente nuevamente.', 'error');
        } finally {
          this.uploadingSignature = false;
        }
      },
  
      // Flow
      showButtons() {
        this.OkButton = false;
        this.showButtonsforOperator = true;
      },
      confirmAndSendDateTime(button, timeKey) {
        Swal.fire({
          title: '¿Estás seguro?', text: `¿Quieres marcar el ${button}?`, icon: 'warning',
          showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, hacerlo!', cancelButtonText: 'No, cancelar!',
        }).then((res) => { if (res.isConfirmed) this.sendDateTime(button, timeKey); });
      },
      async sendDateTime(button, timeKey) {
        const dateTime = new Date().toISOString();
        this.assignation[timeKey] = dateTime;
  
        if (timeKey === 'start_time' && this.assignation.assistance_note.status === 3) {
          this.assignation.assistance_note.status = 1;
        }
  
        await this.updateAssignationStatus(timeKey, dateTime);
  
        if (button === 'termino') {
          try {
            const payload = [{ unit: this.assignation.unit.unit_short_id }];
            const apiDirectory = process.env.API_DIRECTORY;
            await axios.post(`${apiDirectory}/auto-update-unit-status`, payload);
          } catch (e) { console.error('Error updating unit status:', e); }
        }
      },
      async updateAssignationStatus(timeKey, dateTime) {
        const payload = { [timeKey]: dateTime };
        const assignation_id = this.assignation.id;
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          await axios.patch(`${apiDirectory}/assignation-detail/${assignation_id}/`, payload);
        } catch (e) { console.error('Error updating assignation status:', e); }
      },
  
      // KM
      async updateUnitTachometer() {
        const assignation_id = this.assignation.id;
        const data = {
          start_km: this.assignation.start_km,
          end_km: this.assignation.end_km,
        };
  
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          await axios.patch(`${apiDirectory}/assignation-detail/${assignation_id}/`, data);
          Swal.fire('¡Completado!', 'El kilometraje se actualizó con éxito', 'success').then(() => location.reload());
        } catch (e) {
          console.error('Error updating assignation data:', e);
          Swal.fire('¡Error!', 'Verifique que los kilometrajes introducidos son válidos', 'error');
        }
      },
  
      // Map
      loadGoogleMapsAPI() {
        const script = document.createElement('script');
        const apiKey = process.env.GOOGLE_API_KEY;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true; script.defer = true;
        script.onload = () => this.initializeMap();
        document.head.appendChild(script);
      },
      initializeMap() {
        const directionsService = new google.maps.DirectionsService();
        const map = new google.maps.Map(document.getElementById('map'), { zoom: 12, center: this.mapCenter });
        const directionsRenderer = new google.maps.DirectionsRenderer({ polylineOptions: { strokeColor: '#7c3aed' }, map });
        const request = { origin: this.origin, destination: this.destination, travelMode: 'DRIVING' };
        directionsService.route(request, (result, status) => {
          if (status === 'OK') directionsRenderer.setDirections(result);
          else console.error('Error fetching route:', status);
        });
      },
      getUserLocationAndOpenGoogleMaps() {
        if (!navigator.geolocation) { Swal.fire('Error', 'La geolocalización no está soportada por este navegador.', 'error'); return; }
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLoc = `${position.coords.latitude},${position.coords.longitude}`;
            const src = this.assignation.assistance_note.source;
            const dst = this.assignation.assistance_note.destination;
            const origin = `${src.lat},${src.lon}`;
            const destination = `${dst.lat},${dst.lon}`;
            const almostEqual = (a, b, eps = 1e-6) => Math.abs(Number(a) - Number(b)) <= eps;
            const samePoint = almostEqual(src.lat, dst.lat) && almostEqual(src.lon, dst.lon);
            const url = samePoint
              ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}&travelmode=driving`
              : `https://www.google.com/maps/dir/?api=1&waypoints=${encodeURIComponent(origin)}&origin=${encodeURIComponent(userLoc)}&destination=${encodeURIComponent(destination)}&travelmode=driving`;
            window.open(url, '_blank');
          },
          () => Swal.fire('Error', 'No se pudo obtener la ubicación actual.', 'error'),
        );
      },
  
      // Images
      async fetchImages() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-files/`, {
            params: { object_id: this.assignation.assistance_note.note_ident, object_type: 'note' },
          });
          const files = response.data;
          this.clearImages();
          this.populateImages(files);
        } catch (e) { console.error('Error fetching images:', e); }
      },
      populateImages(files) {
        files.forEach((file) => {
          const section = this.imageSections.find((s) => s.loc === file.metadata.loc);
          if (section) {
            section.images.uploaded.push(`data:image/jpeg;base64,${file.content}`);
            section.images.blob_ids.push(file.file_id);
          }
        });
      },
      clearImages() { this.imageSections.forEach((s) => { s.images.uploaded = []; s.images.blob_ids = []; }); },
      getProportionalCompressionQuality(size) {
        const maxSize = 10000000, minQ = 0.4, maxQ = 0.9;
        return Math.max(minQ, Math.min(maxQ, maxQ - (size / maxSize) * (maxQ - minQ)));
      },
      compressAndConvertToJPG(file) {
        return new Promise((resolve, reject) => {
          const quality = this.getProportionalCompressionQuality(file.size);
          new Compressor(file, {
            quality, convertSize: 5000000,
            success(result) {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(new Error('Error reading the file.'));
              reader.readAsDataURL(result);
            },
            error(err) { reject(err); },
          });
        });
      },
      selectFile() {
        return new Promise((resolve) => {
          const input = document.createElement('input');
          input.type = 'file'; input.accept = 'image/*';
          input.onchange = (e) => resolve(e.target.files[0]);
          input.click();
        });
      },
      async uploadFile(section) {
        const file = await this.selectFile();
        if (!file) { Swal.fire('¡Error!', 'Ocurrió un error al subir el archivo. Intente de nuevo.', 'error'); return; }
        this.uploadingImage = true;
        this.uploadProgress = 0;
        try {
          const base64 = await this.compressAndConvertToJPG(file);
          const res = await fetch(base64);
          const blob = await res.blob();
          const jpgFile = new File([blob], 'image.jpg', { type: 'image/jpeg' });

          const formData = new FormData();
          formData.append('file', jpgFile);
          formData.append('object_type', 'note');
          formData.append('object_id', this.assignation.assistance_note.note_ident);
          formData.append('object_metadata', JSON.stringify({ loc: section.loc }));

          const apiDirectory = process.env.API_DIRECTORY;
          await axios.post(`${apiDirectory}/upload-file`, formData, {
            onUploadProgress: (ev) => {
              if (ev.total) this.uploadProgress = Math.round((100 * ev.loaded) / ev.total);
              else this.uploadProgress = 50;
            },
          });
          this.uploadProgress = 100;
          await this.fetchImages();
          Swal.fire('¡Completado!', 'La imagen se subió correctamente.', 'success');
        } catch (e) {
          console.error('Error uploading file:', e);
          Swal.fire('¡Error!', 'No se pudo subir la imagen. Verifica tu conexión e intenta de nuevo.', 'error');
        } finally {
          this.uploadingImage = false;
          this.uploadProgress = 0;
        }
      },
      async deleteImage(section, index) {
        const blobId = section.images.blob_ids[index];
        if (!blobId) { Swal.fire('¡Error!', 'Ocurrió un error al eliminar el archivo. Intente de nuevo.', 'error'); return; }
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          await axios.post(`${apiDirectory}/delete-file/`, { blob_id: blobId });
          section.images.uploaded.splice(index, 1);
          section.images.blob_ids.splice(index, 1);
          Swal.fire('¡Completado!', 'La imagen se eliminó con éxito', 'success');
        } catch (e) {
          console.error('Error deleting image:', e);
          Swal.fire('¡Error!', 'No se pudo eliminar la imagen. Intente de nuevo.', 'error');
        }
      },
  
      // Data
      async fetchAssignations() {
        const assignation_id = this.$route.params.assignation_id;
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const { data } = await axios.get(`${apiDirectory}/assignation-detail/${assignation_id}/`);
          this.assignation = data;
  
          if (this.assignation.client_signature) this.loadSignature(this.assignation.client_signature);
  
          this.origin = { lat: parseFloat(this.assignation.assistance_note.source.lat), lng: parseFloat(this.assignation.assistance_note.source.lon) };
          this.destination = { lat: parseFloat(this.assignation.assistance_note.destination.lat), lng: parseFloat(this.assignation.assistance_note.destination.lon) };
          this.mapCenter = this.origin || this.mapCenter;
  
          this.initializeMap();
        } catch (e) { console.error('Failed to fetch assignations:', e); }
      },
      async saveInventory() {
        const noteID = this.assignation.assistance_note.note_ident;
        const apiDirectory = process.env.API_DIRECTORY;
        await axios.put(`${apiDirectory}/notes/${noteID}/`, this.assignation.assistance_note);
        Swal.fire('¡Actualizado!', 'Los datos se han actualizado con éxito.', 'success').then(() => window.location.reload());
      },
    },
  
    async created() {
      await this.fetchAssignations();
      this.loadGoogleMapsAPI();
      this.fetchImages();
    },
  };
  </script>
  